// Fiche client normalisée (valeurs par défaut des champs). Utilisée par l'ERP au chargement des
// clients et par le serveur (migration « clientsComplets », Nils 28/10) : les deux doivent donner
// exactement la même fiche, sinon un compte qui ne peut pas modifier les fiches (commercial) se voit
// refuser son enregistrement pour des champs que son écran a seulement complétés.
export const TYPES_CLIENT = ["Cuisiniste", "Promoteur", "Architecte", "Marbrier", "Divers Particulier", "Autre"];
export const MIGRATION_TYPES_CLIENT = { Particulier: "Divers Particulier", Entreprise: "Autre", Revendeur: "Autre" };

// On conserve tous les champs enregistrés (aValider, creePar, validePar… — Step 10 pt.11), puis on
// normalise les champs historiques. nouvelId : fabrique d'identifiant pour une fiche qui n'en a pas.
export function normaliserClient(c, nouvelId) {
  return {
    ...c,
    id: c.id || nouvelId(),
    // nom = nom commercial, celui qu'emploie l'équipe au quotidien.
    // raisonSociale = nom de facturation, qui figure sur les documents officiels.
    nom: c.nom || "",
    raisonSociale: c.raisonSociale || "",
    commercialSC: c.commercialSC || "",
    apporteurAffaire: c.apporteurAffaire || "",
    type: MIGRATION_TYPES_CLIENT[c.type] || c.type || TYPES_CLIENT[0],
    // 3 notes relationnelles (lettres) + paiement (couleur, compta)
    notes_adv: c.notes_adv || "–",
    notes_prod: c.notes_prod || "–",
    notes_com: c.notes_com || "–",
    paiement_niveau: c.paiement_niveau || "",
    ice: c.ice || "",
    paiement: c.paiement || "",
    remise: c.remise || "", // remise habituelle en %, valeur par défaut des devis
    plafondExposition: c.plafondExposition || "", // seuil en MAD, comparé à l'encours au BDC et au BL (Nils 02/10)
    contacts: Array.isArray(c.contacts) ? c.contacts : [],
    adresse: c.adresse || "",
    codePostal: c.codePostal || "",
    ville: c.ville || "",
    adressesSupp: Array.isArray(c.adressesSupp) ? c.adressesSupp : [],
    notes: c.notes || "",
  };
}
